module.exports = __webpack_public_path__ + "static/media/nbc-news.6888d5cc.jpg";